module.exports = __webpack_public_path__ + "xdomain.js";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/~/file-loader?name=xdomain.js!/mnt/jenkins/jobs/master/workspace/core/client/vendor/xdomain.js
 ** module id = 512
 ** module chunks = 0 1 2 3 5 11
 **/